import './glide-init';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import '../scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  // ===== SEARCH TOGGLE =====
  const toggle = document.querySelector('.frx-search-toggle');
  const panel = document.querySelector('#frx-search-panel');
  const closeBtn = document.querySelector('.frx-search__close');

  const openSearch = () => {
    if (!panel) return;
    panel.hidden = false;
    toggle?.setAttribute('aria-expanded', 'true');

    const input = panel.querySelector('input[type="search"], input.search-field');
    if (input) setTimeout(() => input.focus(), 50);
  };

  const closeSearch = () => {
    if (!panel) return;
    panel.hidden = true;
    toggle?.setAttribute('aria-expanded', 'false');
  };

  toggle?.addEventListener('click', () => {
    if (panel?.hidden) openSearch();
    else closeSearch();
  });

  closeBtn?.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  document.addEventListener('click', (e) => {
    if (!panel || panel.hidden) return;
    const isInside = panel.contains(e.target) || toggle.contains(e.target);
    if (!isInside) closeSearch();
  });

  // ===== TOPBAR ROTATOR =====
  const topbar = document.querySelector('.frx-topbar');
  if (topbar) {
    let messages = [];
    try { messages = JSON.parse(topbar.getAttribute('data-messages') || '[]'); } catch(e) {}
    const current = topbar.querySelector('.frx-topbar__current');
    const prev = topbar.querySelector('.frx-topbar__btn--prev');
    const next = topbar.querySelector('.frx-topbar__btn--next');

    if (messages.length && current) {
      let i = 0;
      const render = () => current.textContent = messages[i] || '';
      const go = (dir) => {
        i = (i + dir + messages.length) % messages.length;
        render();
      };

      prev?.addEventListener('click', () => go(-1));
      next?.addEventListener('click', () => go(1));

      render();
      setInterval(() => go(1), 4500);
    }
  }

  // ===== MOBILE MENU TOGGLE =====
  const burger = document.querySelector('.frx-burger');
  const nav = document.querySelector('#site-navigation');

  burger?.addEventListener('click', () => {
    const isOpen = nav?.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

    // ===== PDP size swatches (Woo variations) =====

    const form = document.querySelector('form.variations_form');
    if (!form) return;

    const select = form.querySelector('select[name^="attribute_"]');
    if (!select) return;

    // wrapper
    let wrap = form.querySelector('.frx-variation-swatches');
    if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'frx-variation-swatches';
        // coloca logo depois do select
        select.parentElement.appendChild(wrap);
    }

    const build = () => {
        wrap.innerHTML = '';

        const options = [...select.options].filter(o => o.value);
        options.forEach(opt => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'frx-swatch';
        btn.textContent = opt.textContent.trim();
        btn.dataset.value = opt.value;

        if (opt.disabled) btn.classList.add('is-disabled');
        if (select.value === opt.value) btn.classList.add('is-active');

        btn.addEventListener('click', () => {
            if (opt.disabled) return;

            // seta select e dispara change pro Woo atualizar variação
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));

            // UI active
            [...wrap.querySelectorAll('.frx-swatch')].forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');
        });

        wrap.appendChild(btn);
        });
    };

    // Build inicial
    build();

    // Quando Woo atualizar opções disponíveis (ele mexe no select), rebuild
    form.addEventListener('woocommerce_update_variation_values', build);

    // Se mudar pelo select (fallback), sincroniza active
    select.addEventListener('change', () => {
        [...wrap.querySelectorAll('.frx-swatch')].forEach(b => {
        b.classList.toggle('is-active', b.dataset.value === select.value);
        });
    });


 
    // Hero banner
    const hero = document.querySelector('.glide--banner');
    if (hero) {
    new Glide('.glide--banner', {
        type: 'carousel',
        perView: 1,
        gap: 0,
        autoplay: 4500,
        hoverpause: true,
        animationDuration: 650
    }).mount();
    }

});
// ===== PDP: estoque/últimas unidades por variação =====
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form.variations_form');
  const stockEl = document.querySelector('#frx-pdp-stock');
  const infoEl = document.querySelector('#frx-pdp-info');

  if (!form || !stockEl || !infoEl) return;

  const lowStock = parseInt(infoEl.dataset.lowstock || '3', 10);

  const render = (html) => { stockEl.innerHTML = html; };

  // Quando acha uma variação válida
  form.addEventListener('found_variation', (e) => {
    const v = e.detail?.variation;
    if (!v) return;

    // v.stock_quantity pode vir null dependendo do WC/config
    const qty = typeof v.stock_quantity === 'number' ? v.stock_quantity : null;
    const inStock = v.is_in_stock;

    if (!inStock) {
      render('<span class="frx-stock frx-stock--out">Indisponível</span>');
      return;
    }

    if (qty !== null && qty <= lowStock) {
      render(`<span class="frx-stock frx-stock--low">Últimas ${qty} unidades</span>`);
      return;
    }

    // fallback: usa texto do Woo (availability_html) se existir
    if (v.availability_html && v.availability_html.trim().length) {
      // limpa tags e usa como rótulo
      const text = v.availability_html.replace(/<[^>]*>/g, '').trim();
      if (text) {
        render(`<span class="frx-stock frx-stock--ok">${text}</span>`);
        return;
      }
    }

    render('<span class="frx-stock frx-stock--ok">Em estoque</span>');
  });

  // Quando reseta variações
  form.addEventListener('reset_data', () => {
    render('<span class="frx-stock frx-stock--hint">Selecione um tamanho para ver a disponibilidade</span>');
  });
});


// ===== Quantity stepper (+ / -) robusto =====
document.addEventListener('DOMContentLoaded', () => {
  const qtyWrap = document.querySelector('form.cart .quantity');
  if (!qtyWrap) return;

  const input = qtyWrap.querySelector('input.qty');
  if (!input) return;

  // evita duplicar
  if (qtyWrap.closest('.frx-qty')) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'frx-qty';

  const minus = document.createElement('button');
  minus.type = 'button';
  minus.className = 'frx-qty__btn frx-qty__btn--minus';
  minus.setAttribute('aria-label', 'Diminuir quantidade');
  minus.textContent = '−';

  const plus = document.createElement('button');
  plus.type = 'button';
  plus.className = 'frx-qty__btn frx-qty__btn--plus';
  plus.setAttribute('aria-label', 'Aumentar quantidade');
  plus.textContent = '+';

  // monta
  const parent = qtyWrap.parentElement;
  wrapper.appendChild(minus);
  wrapper.appendChild(qtyWrap);
  wrapper.appendChild(plus);

  parent.insertBefore(wrapper, parent.querySelector('.single_add_to_cart_button') || qtyWrap.nextSibling);

  const num = (v) => (v === '' || v === null || typeof v === 'undefined') ? null : Number(v);

  const getMin = () => {
    const m = num(input.getAttribute('min'));
    return Number.isFinite(m) ? m : 1;
  };

  const getMax = () => {
    const m = num(input.getAttribute('max'));
    return Number.isFinite(m) ? m : Infinity;
  };

  const getStep = () => {
    const s = num(input.getAttribute('step'));
    return Number.isFinite(s) && s > 0 ? s : 1;
  };

  const clamp = (v) => Math.max(getMin(), Math.min(getMax(), v));

  const syncButtons = () => {
    const v = num(input.value) || getMin();
    const min = getMin();
    const max = getMax();
    minus.disabled = v <= min;
    plus.disabled = v >= max;
  };

  const commit = () => {
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncButtons();
  };

  minus.addEventListener('click', () => {
    const step = getStep();
    const v = num(input.value) || getMin();

    // usa stepDown se existir (respeita step nativo)
    if (typeof input.stepDown === 'function') {
      input.stepDown();
      input.value = clamp(num(input.value) || getMin());
    } else {
      input.value = clamp(v - step);
    }
    commit();
  });

  plus.addEventListener('click', () => {
    const step = getStep();
    const v = num(input.value) || getMin();

    if (typeof input.stepUp === 'function') {
      input.stepUp();
      input.value = clamp(num(input.value) || getMin());
    } else {
      input.value = clamp(v + step);
    }
    commit();
  });

  input.addEventListener('input', () => {
    input.value = clamp(num(input.value) || getMin());
    syncButtons();
  });

  // para produtos variáveis: o max muda quando escolhe a variação
  const form = document.querySelector('form.variations_form');
  if (form) {
    form.addEventListener('found_variation', syncButtons);
    form.addEventListener('reset_data', syncButtons);
  }

  syncButtons();
});

// FRX: entrance animation (IntersectionObserver) para hero + tiles
(function () {
  const targets = document.querySelectorAll(
    '.frx-hero, .frx-home-tiles .frx-tile'
  );

  if (!targets.length) return;

  // Marca todos como animáveis e aplica um delay leve em sequência
  targets.forEach((el, i) => {
    el.classList.add('frx-animate');
    el.style.setProperty('--frx-delay', `${Math.min(i, 10) * 80}ms`);
  });

  // Fallback sem IO
  if (!('IntersectionObserver' in window)) {
    targets.forEach(el => el.classList.add('is-inview'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        io.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15,
      rootMargin: '0px 0px -10% 0px',
    }
  );

  targets.forEach(el => io.observe(el));
})();

